<img src="../../images/site-logo.svg" alt="[[ site.name ]]">